import { ReactNode } from 'react';
import { Box } from '@cad-arc';
import { colors } from '../../colors/colors';

interface HighlightBoxProps {
    highlight?: boolean;
    children: ReactNode;
    onClick?: () => void;
}

export function HighlightBox({ highlight = false, children, onClick }: HighlightBoxProps) {
    return (
        <Box
            background={highlight ? colors.locationHighlightBoxBackground : undefined}
            color={highlight ? colors.locationHighlightBoxText : undefined}
            padding="1px"
            borderRadius="3px"
            sx={{
                p: {
                    color: highlight ? colors.locationHighlightBoxText : undefined,
                },
            }}
            onClick={onClick}
        >
            {children}
        </Box>
    );
}
